var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.5 17.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 0.916961V3.99999C10.5 5.10456 11.3954 5.99999 12.5 5.99999H15.75M5.99999 10H10.5M8.24999 7.75V12.25M12.75 16.75H3.75003C2.09318 16.75 0.750039 15.4069 0.750033 13.75L0.75 3.75001C0.749995 2.09315 2.09314 0.749998 3.75 0.75L10.1832 0.750005C10.3873 0.750005 10.5843 0.824904 10.7368 0.960497L15.4703 5.16805C15.6482 5.32619 15.75 5.55286 15.75 5.79089V13.75C15.75 15.4069 14.4068 16.75 12.75 16.75Z",
    stroke: "var(--stroke-0, #4858A8)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOrder);
export default __webpack_public_path__ + "static/media/new-order.2139691a7233af92862452a5be4a96df.svg";
export { ForwardRef as ReactComponent };